import React, { useEffect, useState } from 'react';
import { useAuth } from './UserContext';
import { Navigate } from 'react-router-dom';
import './ProtectedRoute.css';
import loadingImage from '../Assests/proIcon.png';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, logout } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="protected_route_loading">
        <div id="loader" className="loading-spinner">
          <img src={loadingImage} alt="Isecurion Logo" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
